import { library } from "../../libraries";
export const NewsletterFormBlock = (props)=>library().newsletterBlock(props);
